import { Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { MenuItem, Select, Collapse, Paper, TableSortLabel, TextField, Autocomplete, ListItem, TableCell, TableRow, Typography, Icon, Tooltip, Skeleton, CircularProgress, Snackbar, Alert } from "@mui/material";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { map as map_1, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { int32ToString, defaultOf as defaultOf_1, createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { fromSeconds } from "./fable_modules/fable-library-js.4.24.0/TimeSpan.js";
import { append as append_1, tryFind, initialize, map, fill } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { isNullOrWhiteSpace } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { tryStr, Machine_getNameOrCode } from "./Shared/Shared.js";
import EventAvailable from "@mui/icons-material/EventAvailable";
import Check from "@mui/icons-material/Check";
import EventBusy from "@mui/icons-material/EventBusy";
import EventNote from "@mui/icons-material/EventNote";

/**
 * Helper function to allow use of old deprecated "onPageChange" table pagination function.
 */
export function onPageChange(setPage, _arg, newPage) {
    setPage(newPage);
}

export class SnackAlertLevel extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Err", "Info", "Success", "Warning"];
    }
}

export function SnackAlertLevel_$reflection() {
    return union_type("ViewHelpers.SnackAlertLevel", [], SnackAlertLevel, () => [[], [], [], []]);
}

export function SnackAlertLevel__get_muiProp(this$) {
    switch (this$.tag) {
        case 1:
            return ["severity", "info"];
        case 2:
            return ["severity", "success"];
        case 3:
            return ["severity", "warning"];
        default:
            return ["severity", "error"];
    }
}

export function errorBanner(errMsg, dismiss) {
    if (errMsg != null) {
        return MuiHelpers_createElement(Alert, [["severity", "error"], ["variant", "outlined"], ["onClose", (_arg) => {
            dismiss();
        }], ["children", errMsg]]);
    }
    else {
        return defaultOf();
    }
}

export function snackInfo(infoMsg, dismiss) {
    return MuiHelpers_createElement(Snackbar, [["anchorOrigin", {
        vertical: "bottom",
        horizontal: "center",
    }], ["open", infoMsg != null], ["onClose", (_arg_1, v) => {
        dismiss();
    }], ["autoHideDuration", 20000], ["children", MuiHelpers_createElement(Alert, [["severity", "info"], ["variant", "filled"], ["onClose", (_arg_2) => {
        dismiss();
    }], ["children", defaultArg(infoMsg, "")]])]]);
}

export function loadingIndicator() {
    return MuiHelpers_createElement(CircularProgress, [["size", 25], ["style", {
        color: "hsl(207.3, 30.8%, 21%)",
    }]]);
}

export function loadingIndicatorSmall() {
    return MuiHelpers_createElement(CircularProgress, [["size", 15], ["style", {
        color: "hsl(207.3, 30.8%, 21%)",
    }]]);
}

export function loadingIndicatorLarge() {
    return MuiHelpers_createElement(CircularProgress, [["size", 40], ["style", {
        color: "hsl(207.3, 30.8%, 21%)",
    }]]);
}

export function listLoadingIndicator(entryHeight) {
    let elems;
    const loadingIndicator_1 = () => MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
        width: 100 + "%",
        minHeight: entryHeight,
    }]]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
    }], (elems = [loadingIndicator_1(), loadingIndicator_1(), loadingIndicator_1()], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

/**
 * Wraps your element in a Mui.tooltip
 */
export function wrapTooltip(text, child) {
    return MuiHelpers_createElement(Tooltip, [["title", text], ["children", child]]);
}

/**
 * Simple helper function that wraps your given element in a span, so that the disabled element can get tooltips
 */
export function disabledTooltip(text, child) {
    return wrapTooltip(text, createElement("span", {
        children: child,
    }));
}

/**
 * Conditionally wrap your given element in a span, so that the disabled element can get
 * tooltips. E.g.: only when admin
 */
export function condDisabledTooltip(text, wrap, child) {
    if (wrap) {
        return disabledTooltip(text, child);
    }
    else {
        return child;
    }
}

/**
 * Conditionally wrap your given element in a tooltip
 */
export function condTooltip(text, wrap, child) {
    if (wrap) {
        return wrapTooltip(text, child);
    }
    else {
        return child;
    }
}

export function tryFocus(elemId) {
    try {
        document.getElementById(elemId).focus();
    }
    catch (matchValue) {
    }
}

export function collapsableHeader(title, collapsed, setCollapsed) {
    let elems_1, elements, props_1;
    return createElement("div", createObj(ofArray([["onClick", (_arg) => {
        setCollapsed(!collapsed);
    }], ["style", {
        marginTop: 1 + "rem",
        marginBottom: 1 + "rem",
        cursor: "pointer",
        width: 100 + "%",
        display: "flex",
        alignItems: "center",
    }], (elems_1 = [MuiHelpers_createElement(Icon, [["style", createObj(toList(delay(() => append(singleton(["fontSize", 1.5 + "rem"]), delay(() => append(singleton(["transitionProperty", "transform"]), delay(() => append(singleton(["transitionDuration", 300 + "ms"]), delay(() => append(singleton(["display", "flex"]), delay(() => (!collapsed ? singleton(["transform", ("rotate(" + 90) + "deg)"]) : empty()))))))))))))], (elements = [(props_1 = {}, react.createElement(ChevronRight, props_1))], ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(Typography, [["style", {
        marginLeft: 3,
    }], ["variant", "h5"], ["children", title]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function customComponent(elem, elemProps) {
    return (props) => elem(toList(delay(() => append(elemProps, delay(() => (Object.entries(props)))))));
}

export function horizontalCollapse(collapsed, children) {
    return createElement("div", {
        style: {
            transitionProperty: "width",
            transitionDuration: fromSeconds(0.5) + "ms",
            width: collapsed ? (25 + "ch") : (0 + "ch"),
            overflow: "hidden",
        },
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

/**
 * Add a specified number of skeleton rows to your table while loading
 */
export function skeletonRows(colSpan, numRows) {
    let elements_1, elements;
    return fill(new Array(numRows), 0, numRows, MuiHelpers_createElement(TableRow, [(elements_1 = [MuiHelpers_createElement(TableCell, [["colSpan", colSpan], ["padding", "none"], (elements = [MuiHelpers_createElement(Skeleton, [["height", 30 + "px"]])], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]));
}

/**
 * Add a specified number of skeleton rows to your table while loading
 */
export function skeletonDivRows(colSpan, numRows) {
    return map(() => {
        let elements_1, elements;
        return MuiHelpers_createElement(TableRow, [["component", "div"], (elements_1 = [MuiHelpers_createElement(TableCell, [["colSpan", colSpan], ["padding", "none"], ["component", "div"], (elements = [MuiHelpers_createElement(Skeleton, [["height", 3 + "rem"]])], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]);
    }, initialize(numRows, (value) => {
    }));
}

/**
 * Add a specified number of skeleton rows while loading
 */
export function skeletonList(numRows) {
    return map(() => {
        let elements;
        return MuiHelpers_createElement(ListItem, [(elements = [MuiHelpers_createElement(Skeleton, [["width", 100 + "%"], ["height", 48 + "px"]])], ["children", reactApi.Children.toArray(Array.from(elements))])]);
    }, initialize(numRows, (value) => {
    }));
}

/**
 * Controlled autocomplete for selecting a single machines with text input for quick client side search
 */
export function machineAutocomplete(locale, selectedMachineOpt, machines, onChange) {
    const machineNameMissing = machines.some((m) => isNullOrWhiteSpace(m.Name));
    const emptyMachineNameChosen = defaultArg(map_1((machine) => isNullOrWhiteSpace(machine.Name), selectedMachineOpt), false);
    return MuiHelpers_createElement(Autocomplete, [["options", Array.from(machines)], ["value", defaultArg(selectedMachineOpt, defaultOf_1())], ["getOptionLabel", (item) => Machine_getNameOrCode({
        code: item.Code,
        name: item.Name,
    })], ["onChange", (_arg, v, _arg_1) => {
        onChange(v);
    }], ["renderInput", (props) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(props), delay(() => ((machineNameMissing && emptyMachineNameChosen) ? singleton(["helperText", [`* ${locale.t("Services.MissingMachineName")}`]]) : empty()))))))]]);
}

export function headerSortCell(sortKey, asc, onClick, key, label) {
    return MuiHelpers_createElement(TableCell, [["style", {
        fontWeight: "bold",
    }], ["variant", "head"], ["children", MuiHelpers_createElement(TableSortLabel, toList(delay(() => append(singleton(["onClick", (_arg) => {
        onClick(key);
    }]), delay(() => append(asc ? singleton(["direction", "asc"]) : singleton(["direction", "desc"]), delay(() => append(singleton(["active", key === sortKey]), delay(() => singleton(["children", label]))))))))))]]);
}

/**
 * Component with expanding filter/body when clicking header
 */
export function CollapsibleContainerWithFilter(collapsibleContainerWithFilterInputProps) {
    let elems_4, elems_1, elements_2;
    const defaultState = collapsibleContainerWithFilterInputProps.defaultState;
    const bodyContent = collapsibleContainerWithFilterInputProps.bodyContent;
    const filterContent = collapsibleContainerWithFilterInputProps.filterContent;
    const headerContent = collapsibleContainerWithFilterInputProps.headerContent;
    const patternInput = reactApi.useState(defaultState);
    const collapsed = patternInput[0];
    return MuiHelpers_createElement(Paper, [["style", {
        padding: 20,
        paddingTop: 5,
        width: 100 + "%",
    }], (elems_4 = [createElement("div", createObj(ofArray([["onClick", (_arg) => {
        patternInput[1](!collapsed);
    }], ["style", {
        marginTop: 1 + "rem",
        marginBottom: 1 + "rem",
        cursor: "pointer",
        width: 100 + "%",
        display: "flex",
        alignItems: "center",
    }], (elems_1 = toList(delay(() => {
        let elements, props_1;
        return append(singleton(MuiHelpers_createElement(Icon, [["style", createObj(toList(delay(() => append(singleton(["fontSize", 2 + "rem"]), delay(() => append(singleton(["transitionProperty", "transform"]), delay(() => append(singleton(["transitionDuration", 300 + "ms"]), delay(() => append(singleton(["display", "flex"]), delay(() => (!collapsed ? singleton(["transform", ("rotate(" + 90) + "deg)"]) : empty()))))))))))))], (elements = [(props_1 = {
            style: {
                fontSize: 1.75 + "rem",
            },
        }, react.createElement(ChevronRight, props_1))], ["children", reactApi.Children.toArray(Array.from(elements))])])), delay(() => headerContent));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), MuiHelpers_createElement(Collapse, [["in", !collapsed], ["collapsedSize", "200px"], (elements_2 = toList(delay(() => {
        let elements_1;
        return append(singleton(MuiHelpers_createElement(Collapse, [["in", !collapsed], (elements_1 = toList(delay(() => filterContent)), ["children", reactApi.Children.toArray(Array.from(elements_1))])])), delay(() => bodyContent));
    })), ["children", reactApi.Children.toArray(Array.from(elements_2))])])], ["children", reactApi.Children.toArray(Array.from(elems_4))])]);
}

export function SnackAlert(snackAlertInputProps) {
    const dismiss = snackAlertInputProps.dismiss;
    const msg = snackAlertInputProps.msg;
    const level = snackAlertInputProps.level;
    const key = snackAlertInputProps.$key;
    const patternInput = reactApi.useState(false);
    const setOpen = patternInput[1];
    let patternInput_1;
    const initial_1 = defaultArg(msg, "");
    patternInput_1 = reactApi.useState(initial_1);
    const dependencies = [msg];
    reactApi.useEffect(() => {
        if (msg != null) {
            patternInput_1[1](msg);
            setOpen(true);
        }
        else {
            setOpen(false);
        }
    }, dependencies);
    return MuiHelpers_createElement(Snackbar, [["anchorOrigin", {
        vertical: "bottom",
        horizontal: "center",
    }], ["open", patternInput[0]], ["onClose", (_arg_1, v) => {
        dismiss();
    }], ["autoHideDuration", 2000], ["children", MuiHelpers_createElement(Alert, [SnackAlertLevel__get_muiProp(level), ["variant", "filled"], ["onClose", (_arg_2) => {
        dismiss();
    }], ["children", patternInput_1[0]]])]]);
}

export function SnackError(snackErrorInputProps) {
    const dismiss = snackErrorInputProps.dismiss;
    const errMsg = snackErrorInputProps.errMsg;
    const patternInput = reactApi.useState(false);
    const setOpen = patternInput[1];
    let patternInput_1;
    const initial_1 = defaultArg(errMsg, "");
    patternInput_1 = reactApi.useState(initial_1);
    const dependencies = [errMsg];
    reactApi.useEffect(() => {
        if (errMsg != null) {
            patternInput_1[1](errMsg);
            setOpen(true);
        }
        else {
            setOpen(false);
        }
    }, dependencies);
    return MuiHelpers_createElement(Snackbar, [["anchorOrigin", {
        vertical: "bottom",
        horizontal: "center",
    }], ["open", patternInput[0]], ["onClose", (_arg_1, v) => {
        dismiss();
    }], ["autoHideDuration", 20000], ["children", MuiHelpers_createElement(Alert, [["severity", "error"], ["variant", "filled"], ["onClose", (_arg_2) => {
        dismiss();
    }], ["children", patternInput_1[0]]])]]);
}

export function Company_selection(locale, disabled, selectedOpt, companies, onSelect) {
    let elements, array_3;
    return MuiHelpers_createElement(Select, [["style", {
        minWidth: 15 + "ch",
    }], ["size", "small"], ["disabled", disabled], ["fullWidth", false], ["value", defaultArg(map_1((dep) => int32ToString(dep.Id), selectedOpt), locale.t("None"))], ["onChange", (e, _arg) => {
        const depId = e.target.value;
        onSelect(tryFind((dep_1) => (dep_1.Id === depId), companies));
    }], (elements = [(array_3 = map((dep_2) => MuiHelpers_createElement(MenuItem, [["value", dep_2.Id], ["children", defaultArg(tryStr(dep_2.Abbr), dep_2.Name)]]), companies), append_1([MuiHelpers_createElement(MenuItem, [["value", locale.t("None")], ["children", locale.t("None")]])], array_3))], ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

export function Service_statusIcons(_arg) {
    switch (_arg.tag) {
        case 1: {
            const props_3 = {
                fontSize: "small",
            };
            return react.createElement(EventAvailable, props_3);
        }
        case 2: {
            const props_5 = {
                fontSize: "small",
            };
            return react.createElement(Check, props_5);
        }
        case 3: {
            const props_7 = {
                fontSize: "small",
            };
            return react.createElement(EventBusy, props_7);
        }
        default: {
            const props_1 = {
                fontSize: "small",
            };
            return react.createElement(EventNote, props_1);
        }
    }
}

